import { ChainLayoutStyle, CycleLayoutStyle, OrthogonalLayout, OrthogonalLayoutData, OrthogonalLayoutStyle, SubstructureOrientation, TreeLayoutStyle } from "yfiles";
import LayoutConfiguration from "./layoutConfiguration";
class OrthogonalLayoutConfig extends LayoutConfiguration {
    createConfiguredLayout() {
        const layout = new OrthogonalLayout({
            subgraphLayoutEnabled: false,
            layoutStyle: OrthogonalLayoutStyle.NORMAL,
            gridSpacing: 15,
            edgeLengthReduction: true,
            optimizePerceivedBends: true,
            uniformPortAssignment: false,
            crossingReduction: true,
            randomization: true,
            faceMaximization: false,
            fromSketchMode: false,
            integratedEdgeLabeling: false,
            considerNodeLabels: true,
            labelingEnabled: true,
            chainStyle: ChainLayoutStyle.STRAIGHT,
            chainSize: 2,
            cycleStyle: CycleLayoutStyle.NONE,
            cycleSize: 4,
            treeStyle: TreeLayoutStyle.COMPACT,
            treeSize: 3,
            treeOrientation: SubstructureOrientation.TOP_TO_BOTTOM,
            hideGroupsStageEnabled: false
        });
        layout.edgeLayoutDescriptor.minimumFirstSegmentLength = 15.0;
        layout.edgeLayoutDescriptor.minimumLastSegmentLength = 15.0;
        layout.edgeLayoutDescriptor.minimumSegmentLength = 15.0;
        return layout;
    }
    createConfiguredLayoutData(_, __, ___, affectedEdges) {
        return new OrthogonalLayoutData({
            directedEdges: affectedEdges ? Array.from(affectedEdges) : undefined
        });
    }
}
export default OrthogonalLayoutConfig;
